// GifSection.js

import React from "react";
import "../Style/videogif.css";

import demoGif from "../assets/demo.gif"; // your gif file

const highlights = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M13 3 4 14h7l-1 7 9-11h-7l1-7Z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    label: "Fast, responsive builds",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <rect x="3" y="4" width="18" height="14" rx="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 21h8M12 18v3" strokeLinecap="round" />
      </svg>
    ),
    label: "Pixel-accurate UI",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M9 12 2 8l7-4 7 4-7 4Z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="m2 8 7 4v8M16 8v8l-7 4M16 8l7-4v8l-7 4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    label: "Built for every screen",
  },
];

const GifSection = () => {
  return (
    <section className="gifshowcase-section">
      <div className="gifshowcase-container">

        {/* LEFT — smaller demo, framed like a browser window */}
        <div className="gifshowcase-media">
          <div className="gifshowcase-card">
            <div className="gifshowcase-card__bar">
              <span className="gifshowcase-dot gifshowcase-dot--red" />
              <span className="gifshowcase-dot gifshowcase-dot--yellow" />
              <span className="gifshowcase-dot gifshowcase-dot--green" />
            </div>
            <img
              src={demoGif}
              alt="Product demo preview"
              className="gifshowcase-image"
            />
          </div>
        </div>

        {/* RIGHT — copy */}
        <div className="gifshowcase-content">
          <span className="gifshowcase-eyebrow">Live Preview</span>

          <h2 className="gifshowcase-heading">
            See How We Bring Interfaces to Life
          </h2>

          <p className="gifshowcase-subtext">
            A quick look at the kind of polished, fluid interaction we build into
            every product — from the first click to the last pixel.
          </p>

          <div className="gifshowcase-highlights">
            {highlights.map((item, index) => (
              <div className="gifshowcase-chip" key={index}>
                <span className="gifshowcase-chip__icon">{item.icon}</span>
                <span className="gifshowcase-chip__label">{item.label}</span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default GifSection;